import { brainGameEntry } from "../types/brainGame/brainGame";

const distribution = [
  { level: 0, probability: 0.5625 },
  { level: 1, probability: 0.25 },
  { level: 2, probability: 0.125 },
  { level: 3, probability: 0.0625 },
];


const getAdjustedDistribution = (items: brainGameEntry[]) => {
  // Liste der vorhandenen Levels im Array
  const existingLevels = Array.from(new Set(items.map(item => item.level)));

  // Filtere die Basisverteilung nur für vorhandene Levels
  const filteredDistribution = distribution.filter(entry => existingLevels.includes(entry.level));

  // Gesamtsumme der Wahrscheinlichkeiten der vorhandenen Levels berechnen
  const totalProbability = filteredDistribution.reduce((sum, entry) => sum + entry.probability, 0);

  // Wahrscheinlichkeiten anpassen, sodass die Summe wieder 1.0 ergibt
  return filteredDistribution.map(entry => ({
    level: entry.level,
    probability: entry.probability / totalProbability,
  }));
}

// Kumulative Wahrscheinlichkeit berechnen
const getCumulativeDistribution = (adjustedDistribution: { level: number; probability: number }[]) => {
  return adjustedDistribution.reduce<{ level: number; cumulative: number }[]>((acc, entry, index) => {
    const cumulative = entry.probability + (index > 0 ? acc[index - 1].cumulative : 0);
    acc.push({ level: entry.level, cumulative });
    return acc;
  }, []);
}


const getRandomLevel = (adjustedCumulative: { level: number; cumulative: number }[]): number => {
  const random = Math.random();
  for (const entry of adjustedCumulative) {
    if (random <= entry.cumulative) {
      return entry.level;
    }
  }
  return adjustedCumulative[adjustedCumulative.length - 1].level;
}


const getRandomItemByLevel = (items: brainGameEntry[]): brainGameEntry | undefined => {
  const adjustedDistribution = getAdjustedDistribution(items);
  const cumulativeDistribution = getCumulativeDistribution(adjustedDistribution);

  const level = getRandomLevel(cumulativeDistribution);

  // Filtere Items nach dem gewählten Level und wähle zufällig eines davon
  const filteredItems = items.filter(item => item.level === level);
  if (filteredItems.length === 0) return undefined;
  return filteredItems[Math.floor(Math.random() * filteredItems.length)];
}

export { getRandomItemByLevel };
